import './SideBar.css';
import { FaSignOut as LogOutIcon } from 'react-icons/lib/fa';
import { connect } from 'react-redux';
import { t } from 'i18next';
import React from 'react';
import { logOut, toggleSidebar } from '../../reducer/actions';
import Navigation from '../navigation/Navigation';
import { AYLA_ALLOWED_ROLES } from '../../constants';

const SideBar = ({
  dispatch, sidebarVisible, isPremium, session
}) => (
  <div className={`SideBar ${sidebarVisible ? 'visible' : 'hidden'}`}>
    <div className="cover"
      onClick={() => dispatch(toggleSidebar())}
      role="presentation"
    />
    <div className="bar">
      <div className="title">
        <img src="close.png"
          alt={t('close')}
          onClick={() => dispatch(toggleSidebar())}
          role="presentation"
        />
        <h1>{t('insights')}</h1>
      </div>
      <Navigation visible
        isPremium={isPremium}
        dispatch={dispatch}
        session={session}
      />
      <hr />
      <a href="/"
        className="withIcon"
        onClick={(e) => { e.preventDefault(); dispatch(toggleSidebar()); dispatch(logOut()); }}
      >
        <LogOutIcon size="20" />
        {t('logout')}
      </a>
    </div>
  </div>
);

export default connect(s => s)(SideBar);
